import { add, listen, qs, qsa, toggle } from "@fluorescent/dom";

import { section } from "@/neon";

section("login", {
  onLoad() {
    const main = qs('[data-part="login"]', this.container);
    const reset = qs('[data-part="reset"]', this.container);
    const toggles = qsa("[data-toggle]", this.container);

    const isSuccess = qs("[data-success]", this.container);
    const successMessage = qs("[data-success-message]", this.container);

    if (isSuccess) {
      add(successMessage, "visible");
    }

    function toggleView(e) {
      e.preventDefault();
      toggle([main, reset], "hide");
    }

    this.toggleClick = listen(toggles, "click", toggleView);
  },

  onUnload() {
    this.toggleClick();
  },
});
